/*! License details at fancyapps.com/license */
import { en_EN as e } from "../../carousel/l10n/en_EN.js";
var o = Object.assign(Object.assign({}, e), {
  CLOSE: "Close",
  NEXT: "Next",
  PREV: "Previous",
  MODAL: "You can close this modal content with the ESC key",
  ELEMENT_NOT_FOUND: "HTML Element Not Found",
  IFRAME_ERROR: "Error Loading Page"
});
export { o as en_EN };